import clsx from 'clsx'
import type { OAuthKinds } from 'src/utils/api'
import { Button } from './Button'
import LoadingSpinner from './LoadingSpinner'

const GoogleIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20">
        <path
            d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
            fill="#4285F4"
        />
        <path
            d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
            fill="#34A853"
        />
        <path
            d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
            fill="#FBBC05"
        />
        <path
            d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
            fill="#EA4335"
        />
        <path d="M1 1h22v22H1z" fill="none" />
    </svg>
)

const GitHubIcon = () => (
    <svg width="20" height="20" viewBox="0 0 98 96" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M48.854 0C21.839 0 0 22 0 49.217c0 21.756 13.993 40.172 33.405 46.69 2.427.49 3.316-1.059 3.316-2.362 0-1.141-.08-5.052-.08-9.127-13.59 2.934-16.42-5.867-16.42-5.867-2.184-5.704-5.42-7.17-5.42-7.17-4.448-3.015.324-3.015.324-3.015 4.934.326 7.523 5.052 7.523 5.052 4.367 7.496 11.404 5.378 14.235 4.074.404-3.178 1.699-5.378 3.074-6.6-10.839-1.141-22.243-5.378-22.243-24.283 0-5.378 1.94-9.778 5.014-13.2-.485-1.222-2.184-6.275.486-13.038 0 0 4.125-1.304 13.426 5.052a46.97 46.97 0 0 1 12.214-1.63c4.125 0 8.33.571 12.213 1.63 9.302-6.356 13.427-5.052 13.427-5.052 2.67 6.763.97 11.816.485 13.038 3.155 3.422 5.015 7.822 5.015 13.2 0 18.905-11.404 23.06-22.324 24.283 1.78 1.548 3.316 4.481 3.316 9.126 0 6.6-.08 11.897-.08 13.526 0 1.304.89 2.853 3.316 2.364 19.412-6.52 33.405-24.935 33.405-46.691C97.707 22 75.788 0 48.854 0z"
            fill="#24292f"
        />
    </svg>
)

const GitLabIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 380 380">
        <g id="LOGO" transform="scale(1.68) translate(-76, -76)">
            <path
                className="cls-1"
                d="M282.83,170.73l-.27-.69-26.14-68.22a6.81,6.81,0,0,0-2.69-3.24,7,7,0,0,0-8,.43,7,7,0,0,0-2.32,3.52l-17.65,54H154.29l-17.65-54A6.86,6.86,0,0,0,134.32,99a7,7,0,0,0-8-.43,6.87,6.87,0,0,0-2.69,3.24L97.44,170l-.26.69a48.54,48.54,0,0,0,16.1,56.1l.09.07.24.17,39.82,29.82,19.7,14.91,12,9.06a8.07,8.07,0,0,0,9.76,0l12-9.06,19.7-14.91,40.06-30,.1-.08A48.56,48.56,0,0,0,282.83,170.73Z"
                fill="#e24329"
            />
            <path
                className="cls-2"
                d="M282.83,170.73l-.27-.69a88.3,88.3,0,0,0-35.15,15.8L190,229.25c19.55,14.79,36.57,27.64,36.57,27.64l40.06-30,.1-.08A48.56,48.56,0,0,0,282.83,170.73Z"
                fill="#fc6d26"
            />
            <path
                className="cls-3"
                d="M153.43,256.89l19.7,14.91,12,9.06a8.07,8.07,0,0,0,9.76,0l12-9.06,19.7-14.91S209.55,244,190,229.25C170.45,244,153.43,256.89,153.43,256.89Z"
                fill="#fca326"
            />
            <path
                className="cls-2"
                d="M132.58,185.84A88.19,88.19,0,0,0,97.44,170l-.26.69a48.54,48.54,0,0,0,16.1,56.1l.09.07.24.17,39.82,29.82s17-12.85,36.57-27.64Z"
                fill="#fc6d26"
            />
        </g>
    </svg>
)

const buttonClasses = clsx('flex-1 gap-2 justify-center !px-3 py-1 h-8 !rounded')
export default function OauthButtons({
    signinGitHub,
    signinGitLab,
    signinGoogle,
    disabled = false,
    pendingKind,
}: {
    signinGitHub: () => void
    signinGitLab?: () => void
    signinGoogle: () => void
    disabled?: boolean
    pendingKind?: OAuthKinds
}) {
    return (
        <div className="flex flex-col items-center space-y-4 w-full">
            <div className="flex gap-x-2 w-full">
                <Button variant="outline" className={buttonClasses} onClick={signinGoogle} disabled={disabled}>
                    <LoadingSpinner isLoading={pendingKind === 'google'} size={16}>
                        <GoogleIcon />
                        <span className="text-xs">Google</span>
                    </LoadingSpinner>
                </Button>
                <Button variant="outline" className={buttonClasses} onClick={signinGitHub} disabled={disabled}>
                    <LoadingSpinner isLoading={pendingKind === 'github'} size={16}>
                        <GitHubIcon />
                        <span className="text-xs">GitHub</span>
                    </LoadingSpinner>
                </Button>
                {signinGitLab !== undefined && (
                    <Button variant="outline" className={buttonClasses} onClick={signinGitLab} disabled={disabled}>
                        <LoadingSpinner isLoading={pendingKind === 'gitlab'} size={16}>
                            <GitLabIcon />
                            <span className="text-xs">GitLab</span>
                        </LoadingSpinner>
                    </Button>
                )}
            </div>
        </div>
    )
}
